import MapPinnedSvg from '@assets/images/svg/map-pinned.svg';
import React from 'react';
import { View } from 'react-native';

export interface MapPinnedIconProps {
    size?: number;
    color?: string;
}

export function MapPinnedIcon({ size = 24, color = '#333333' }: MapPinnedIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <MapPinnedSvg width={size} height={size} color={color} />
        </View>
    );
}

export default MapPinnedIcon;
